import type { FeatureFlagConfig } from '@platform/client/features';

declare module '@platform/core/feature-flags' {
  interface FeatureFlags {
    CYLANCE_CONSOLE_LINKS?: boolean;
  }
}

export default {
  featureFlags: {
    // S2CX-13915: Enable seamless sign on experience between Unified and Cylance portals
    // TODO S2CX-16683: Cleanup feature flag
    CYLANCE_CONSOLE_LINKS: true,
  },
} satisfies FeatureFlagConfig;
